import {Vue} from 'ui.vue';
import {Vuex} from 'ui.vue.vuex';

export default Vuex.store({
	state:{
		service: {
			submitForm: false
		},
		tmp:{
			flowers:{
				1:false,
				2:false,
				3:false,
				4:false,
				5:false,
				6:false,
				7:false,
				8:false,
			},
			queueFlower:[],
		},
		result: {
			cost: 0,
			flowers:{},
			green: '',
			color: '',
			package: '',
			tape: '',
			phone:''
		},
		data:{
			flowers:[
				{
					id:1,
					name:'FLOWER_DISCRETION',
					imagePath:'/img/flower/usmotrenie.jpeg'
				},
				{
					id:2,
					name:'FLOWER_ROZA_50',
					imagePath:'/img/flower/roza-50-sm.jpeg'
				},
				{
					id:3,
					name:'FLOWER_ROZA_KUST',
					imagePath:'/img/flower/roza-kustovaya.jpg'
				},
				{
					id:4,
					name:'FLOWER_IRIS',
					imagePath:'/img/flower/irisy.jpg'
				},
				{
					id:5,
					name:'FLOWER_ALSTROMERIYA',
					imagePath:'/img/flower/alstromeriya.jpg'
				},
				{
					id:6,
					name:'FLOWER_GERBERA',
					imagePath:'/img/flower/gerbery.jpg'
				},
				{
					id:7,
					name:'FLOWER_EUSTOMA',
					imagePath:'/img/flower/eustoma.jpg'
				},
				{
					id:8,
					name:'FLOWER_KHARIZANTEMA',
					imagePath:'/img/flower/kharizantema.jpg'
				},
			],
			colors:[
				{
					id:1,
					name:'COLOR_DELICATE',
					colors:[
						'#fdbccc', '#f3f0e0', '#fff39c', '#c8d99c', '#f3c6ff'
					]
				},
				{
					id:2,
					name:'COLOR_BRIGHT',
					colors:[
						'#c42034', '#f7f7f7', '#ffd643', '#739c3e', '#87479d'
					]
				}
			],
			packaging:[
				{
					id:1,
					name:'PACKAGING_KRAFT',
					imagePath:'/img/packaging/kraft.png'
				},
				{
					id:2,
					name:'PACKAGING_GRID',
					imagePath:'/img/packaging/grid.jpeg'
				},
				{
					id:3,
					name:'PACKAGING_ABAKA',
					imagePath:'/img/packaging/abaka.jpeg'
				},
				{
					id:4,
					name:'PACKAGING_NONE',
					imagePath:'none'
				},
			],
			tapes:[
				{
					id:1,
					name:'TAPE_ATLAS',
					imagePath:'/img/tape/atlas.jpeg'

				},
				{
					id:2,
					name:'TAPE_RAFFIYA',
					imagePath:'/img/tape/raffiya.jpeg'

				},
				{
					id:3,
					name:'TAPE_SIMPLE',
					imagePath:'/img/tape/simple.jpeg'

				},
				{
					id:4,
					name:'TAPE_NONE',
					imagePath:'none'

				},
			]
		},
		error:{
			phone:false
		}
	},
	mutations:{
		changeServiceAfterLoad(state, data){
			state.service = {...state.service, ...data}
		},
		changeCost(state, cost){
			Vue.set(state.result, 'cost', cost);
		},
		changeFlowerInQueue(state, arr){
			Vue.set(state.tmp, 'queueFlower', arr)
		},
		changeActiveFlower(state, obj){
			Vue.set(state.tmp, 'flowers', obj)
		},
		changeResultFlower(state, obj){
			Vue.set(state.result, 'flowers', obj)
		},
		changeResultGreen(state, bool){
			Vue.set(state.result, 'green', bool)
		},
		changeColor(state, obj){
			Vue.set(state.result, 'color', obj)
		},
		changePackaging(state, obj){
			Vue.set(state.result, 'package', obj)
		},
		changeTape(state, obj){
			Vue.set(state.result, 'tape', obj)
		},
		setPhone(state, phone){
			Vue.set(state.result, 'phone', phone)
		},
		changeErrorPhone(state, bool){
			Vue.set(state.error, 'phone', bool);
		},
		changeSubmitForm(state,bool){
			Vue.set(state.service, 'submitForm', bool)
		}
	},
	actions:{
		initialState({commit}, data){
			this.dispatch('changeServiceAfterLoad', data.service)
		},
		changeServiceAfterLoad({commit}, data){
			commit('changeServiceAfterLoad', data)
		},
		changeCost({commit}, cost){
			commit('changeCost', cost)
		},
		addFlower({commit, state}, flowerID){
			let objFlower = {...state.tmp.flowers},
				objResultFlower = {...state.result.flowers},
				arrFlowerQueue = [...state.tmp.queueFlower];

			if(objFlower[flowerID] !== true){
				objFlower[flowerID] = true;

				if(arrFlowerQueue.length >= 3){
					let firstEl = arrFlowerQueue[0];
					objFlower[firstEl] = false;
					delete objResultFlower[arrFlowerQueue[0]];
					arrFlowerQueue.shift();
					arrFlowerQueue.push(flowerID)
				}else{
					arrFlowerQueue.push(flowerID)
				}

				for(let i = 0; i <= state.data.flowers.length; ++i){
					if(state.data.flowers[i].id == flowerID){
						objResultFlower[flowerID] = state.data.flowers[i];
						break;
					}
				}

				commit('changeResultFlower', objResultFlower)
				commit('changeFlowerInQueue', arrFlowerQueue)
				commit('changeActiveFlower', objFlower)
			}
		},
		removeFlower({commit, state}, flowerID){
			let objFlower = {...state.tmp.flowers},
				objResultFlower = {...state.result.flowers},
				arrFlowerQueue = [...state.tmp.queueFlower];

			if(objFlower[flowerID] === true){
				objFlower[flowerID] = false;

				for(let i = 0; i <= arrFlowerQueue.length; ++i){
					if(arrFlowerQueue[i] == flowerID){
						arrFlowerQueue.splice(i, 1);
						break;
					}
				}

				delete objResultFlower[flowerID];

				commit('changeResultFlower', objResultFlower)
				commit('changeFlowerInQueue', arrFlowerQueue)
				commit('changeActiveFlower', objFlower)
			}

		},
		changeResultGreen({commit}, bool){
			commit('changeResultGreen', bool)
		},
		changeColor({commit, state}, id){
			let objColor = state.data.colors[id];
			commit('changeColor', objColor)
		},
		changePackaging({commit, state}, id){
			let newPackaging = state.data.packaging[id];
			commit('changePackaging', newPackaging);
		},
		changeTape({commit, state}, id){
			let newTape = state.data.tapes[id];
			commit('changeTape', newTape);
		},
		setPhone({commit}, phone){
			commit('setPhone', phone)
			if(phone.length >= 8){
				commit('changeErrorPhone', false);
			}else{
				commit('changeErrorPhone', true);
			}
		},
		submitBuilder({commit, state}){
			let cost = state.result.cost;
			let dataFlowers = [...state.data.flowers],
				resultFlowers = {...state.result.flowers},
				flowers = [];
			let green = state.result.green;
			let color = state.result.color.name;
			let packageName = state.result.package.name;
			let tape = state.result.tape.name;
			let phone = state.result.phone;

			if(phone.length < 8){
				commit('changeErrorPhone', true);
				return;
			}

			for(let i = 0; i <= dataFlowers.length; ++i){
				if(resultFlowers[i]){
					flowers.push(resultFlowers[i].name)
				}
			}

			let post = {
				cost,
				flowers,
				green,
				color,
				package:packageName,
				tape,
				phone
			}

			BX.ajax.runComponentAction('sw:builder',
				'sendBuilder', {
					mode: 'class',
					data: {post},
				})
				.then(function (response) {
					if (response.status === 'success') {
						commit('changeSubmitForm', true)
						$(".builder_success").show();
						ingEvents.init({debug:true})
						ingEvents.YMReachGoal({type: 'event', label: 'builder', goalParams:{} })
						ingEvents.GAEvent({category:'forms', action:'submit', label:'builder'})
					}
				});
		}
	}
})